module.exports = __webpack_public_path__ + "static/img/3bg_12.440fe6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_12.png
// module id = 679
// module chunks = 1